export const PDP_CONTROL = 0;
export const PDP_NEW_INTERSTITIAL = 1;
export const PDP_PREPAID_INTERSTITIAL = 2;
export const PDP_WARRANTY_INTERSTITIAL = 3;
export const PDP_NEW_PREPAID_INTERSTITIAL = 4;
export const PDP_NEW_WARRANTY_INTERSTITIAL = 5;
